// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2DAbW","actions":"GroupTable_actions__2N9oS","deleteModalFooter":"GroupTable_deleteModalFooter__1ML0L"};